import { render, staticRenderFns } from "./CreateTaskIcon.vue?vue&type=template&id=668e2c28&"
import script from "./CreateTaskIcon.vue?vue&type=script&lang=js&"
export * from "./CreateTaskIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports